import { useEffect, useState } from 'react';
import { Api } from '@infra/api';
import { Specialization, SpecializationCreate } from '@domain/models';
import { Modal } from '../components/Modal';
import { ConfirmDialog } from '../components/ConfirmDialog';
import { DataTable } from '../components/DataTable';

const empty: SpecializationCreate = {
  name: '',
};

export function SpecializationsPage() {
  const [items, setItems] = useState<Specialization[]>([]);
  const [form, setForm] = useState<SpecializationCreate>({ ...empty });
  const [saving, setSaving] = useState(false);
  const [edit, setEdit] = useState<Specialization | null>(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  useEffect(() => {
    Api.listSpecializations().then(setItems).catch(console.error);
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      const created = await Api.createSpecialization(form);
      setItems([created, ...items]);
      setForm({ ...empty });
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <div className="toolbar">
        <div className="title"><h2 style={{margin:0}}>Справочник специализаций</h2></div>
      </div>
      <div className="row">
        <form className="card" onSubmit={submit} style={{maxWidth:560}}>
          <h3 style={{marginTop:0}}>Новая специализация</h3>
          <label htmlFor="specialization-name">Название</label>
          <input
            id="specialization-name"
            value={form.name}
            onChange={e=>setForm({...form, name:e.target.value})}
            required
          />
          <div style={{marginTop:12}}>
            <button disabled={saving}>{saving ? 'Сохранение…' : 'Создать'}</button>
          </div>
        </form>

        <div style={{flex:2}}>
          <DataTable
            data={items}
            title="Список специализаций"
            searchFields={['name']}
            searchPlaceholder="Поиск по названию..."
            onRowClick={(item) => setEdit(item)}
            columns={[
              { key: 'name', title: 'Название' },
            ]}
          />
        </div>
      </div>

      {edit && (
        <Modal title={`Специализация: ${edit.name}`} onClose={()=>setEdit(null)}>
          <div className="row">
            <div>
              <label>Название</label>
              <input
                value={edit.name}
                onChange={e=>setEdit({...edit!, name:e.target.value})}
                required
              />
            </div>
          </div>
          <div style={{marginTop:12, display:'flex', gap:8, alignItems:'center'}}>
            <div style={{display:'flex', gap:8}}>
              <button onClick={async ()=>{ 
                if (edit.id != null) { 
                  const updated = await Api.updateSpecialization(edit.id, { id: edit.id, name: edit.name }); 
                  setItems(items.map(x=> x.id === updated.id ? updated : x)); 
                  setEdit(null); 
                }
              }}>
                Сохранить
              </button>
              <button className="secondary" onClick={()=>setEdit(null)}>Отмена</button>
            </div>
            <button style={{background:'#dc2626', marginLeft:'auto'}} onClick={()=>setConfirmDeleteOpen(true)}>Удалить</button>
          </div>
        </Modal>
      )}

      {edit && (
        <ConfirmDialog
          open={confirmDeleteOpen}
          title="Удаление специализации"
          message={`Вы уверены что хотите удалить специализацию "${edit.name}"?`}
          confirmText="Удалить"
          onClose={()=>setConfirmDeleteOpen(false)}
          onConfirm={async ()=>{
            if (edit.id != null) {
              await Api.deleteSpecialization(edit.id);
              setItems(items.filter(x => x.id !== edit.id));
              setConfirmDeleteOpen(false);
              setEdit(null);
            }
          }}
        />
      )}
    </div>
  );
}

